<template>
	<div id="FrontSearcherEmployee">
	<h2>{{title}}</h2>
	<button @click="SickTest">Sick Test</button>
	<p v-if="SickTestData" v-html="SickTestData"></p>

	</div>
</template>

<script>

export default {
	name: 'FrontSearcherEmployee',

	data () {
		return {
			title: 'REOUTER TEST',
			SickTestData: null,
		}
	},
	methods: {
		SickTest(){
			let self = this;
            jQuery(document).ready(function ($) {
                $.ajax({
                    url: theme_data.theme_ajax,
                    type: 'POST',
                    data: {
						action: 'loadPostsArged',
						security: theme_data.nonce,
						shortinit: 'false',
						args: {
							post_type: 'employees',
							load_views: 'loadViewEmployeesList',
						}
                    }
                }).done(function(data) {
                    self.SickTestData = data.send
                });
            });
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/js/vue/FrontSearcherEmployee.vue?349c91a1